"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var variable_decorator_styles_1 = require("./variable-decorator.styles");

var VariableDecorator = function VariableDecorator(_ref) {
  var contentState = _ref.contentState,
      entityKey = _ref.entityKey,
      children = _ref.children,
      handleClick = _ref.handleClick;
  var entity = contentState.getEntity(entityKey);

  var _entity$getData = entity.getData(),
      variable = _entity$getData.variable;

  return react_1.default.createElement(variable_decorator_styles_1.StyledDecoratorSpan, {
    clickable: !!handleClick,
    onClick: function onClick() {
      return handleClick && handleClick(variable);
    }
  }, children);
};

exports.default = VariableDecorator;